import Vue from 'vue'
import VxeUI from 'vxe-pc-ui'
import VXETable from 'vxe-table'
import i18n from '../i18n'
import './vxetable.scss'

//国际化配置
VXETable.config({ i18n: (key, args) => i18n.t(key, args) })

//表格配置
Vue.use(VxeUI)
Vue.use(VXETable, { zIndex: 9999, version: 0 })
